export default "__VITE_ASSET__3f939dee__"